module.exports = __webpack_public_path__ + "static/media/liveNow.62278fca.svg";